import React, { Component } from 'react';
import Cards from 'react-credit-cards';
import CreditCardInput from '../card/card-input-lib';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import Button from 'react-validation/build/button';
import 'react-credit-cards/es/styles-compiled.css';
import { dependencies } from '../../../../tools/Dependencies';
import axios from "axios";
import { appConfig } from '../../../../tools/AppConfig';
import './InstallmentCard.css';

const required = (value) => {
  if (!value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return <div className="alert alert-danger fieldErrorMessage" role="alert"> This field is required.</div>;
  }
};
class InstallmentCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cardNumber: '',
            cardHolderName: '',
            expiry: '',
            cvc: '',
            focus: '',
            card_error: false,
            card_complate: false,
            saveCard: false,
            // installments
            installmentPlans: [],
            selected_plan: null,
            selected_plan_index: null,
            showInstallment: false,
            showInstallmentPlans: false,
            currentCardNum: "",
            requestedCardNum: "",
            amount: 0,
            currency: ""
        };
    }
    componentDidMount(){
        let data = dependencies.decodePaymentToken(this.props.payment_token)
        let amount = (data.amount_cents / 1000).toFixed(2)
        this.setState({amount, currency: data.currency})
    }
    handleCardNumberChange = (e) => {
        this.setState({cardNumber: e.target.value, card_error: false},() => {
            this.check_card_installments()
            this.check_card_complate()
        });
    }
    handleCardExpiryChange = (e) => {
        this.setState({expiry: e.target.value, card_error: false},() => {
            this.check_card_complate()
        });
    }
    handleCardCVCChange = (e) => {
        this.setState({cvc: e.target.value, card_error: false},() => {
            this.check_card_complate()
            if(this.state.cvc.length === 4){
                document.getElementById("cardHolderInput").focus();
            }
        });
    }
    handelCardHolderName = (e) => {
        this.setState({cardHolderName: e.target.value.toUpperCase()},() => {
            this.check_card_complate()
        });
    }
    handelSaveCardChange = (e) => {
        this.setState({saveCard: e.target.checked},() => {
            this.check_card_complate()
        });
    }
    handleInputFocus = (e) => {
        this.setState({ focus: e.target.name });
    }
    check_card_complate = () => {
        if(
            (this.state.cardNumber.replace(/ /g,'').length === 15 || this.state.cardNumber.replace(/ /g,'').length === 16) &&
            this.state.expiry.replace(/ /g,'').length >= 5 &&
            this.state.cvc.length >= 3 &&
            this.state.cardHolderName.length >= 1 &&
            ((this.state.showInstallmentPlans && this.state.selected_plan) || (!this.state.showInstallmentPlans))
        ){
            this.setState({card_complate: true})
        }else{
            this.setState({card_complate: false})
        }
    }

    check_card_installments (){
        let number = this.state.cardNumber.replace(/\s/g, '');
        if (number.length >= 6) {
            let current_num = number.slice(0, 6) + "0000000000";
            this.setState({currentCardNum: current_num}, () => {
                if (this.state.requestedCardNum != this.state.currentCardNum) {
                    this.setState({requestedCardNum: this.state.currentCardNum}, ()=> {
                        this.getInstallmentPlans();
                    })
                } else {
                    this.setState({showInstallment: true})
                }
            })
        }else{
            this.setState({showInstallment: false, showInstallmentPlans: false})
        }
    }
    getInstallmentPlans() {
        let url = appConfig.getServerUrl() + '/api/auth/bank-installments';
        let config = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        var data = {
            "card_pin": this.state.requestedCardNum,
            "payment_token": this.props.payment_token
        }
        var jsonData = JSON.stringify(data);
        axios.post(
            url,
            jsonData,
            config
        ).then((resp)=>{
            this.setState({installmentPlans: resp.data.installments, showInstallment: true})
        }).catch((err)=>{
            console.log(err.response)
        })
    }
    handle_select_plan (plan, index){
        this.setState({selected_plan: plan, selected_plan_index: index, amount: plan.emi/100}, ()=>{
            this.check_card_complate()
        })
    }
    handleSubmit = (e) => {
        e.preventDefault();
        this.handleInputFocus(e);
        let card_data;
        if(this.state.showInstallmentPlans){
            card_data  = {
                "number": this.state.cardNumber,
                "cardNumber": this.state.cardNumber.replace(/ /g,''),
                "name": this.state.cardHolderName,
                "expiry": this.state.expiry.replace(/ /g,''),
                "expiry_mm": this.state.expiry.replace(/ /g,'').slice(0, 2),
                "expiry_yy": this.state.expiry.replace(/ /g,'').slice(-2),
                "cvc": this.state.cvc,
                "save_card": this.state.saveCard,
                "tenure": this.state.selected_plan.tenure
            }
        }else{
            card_data  = {
                "number": this.state.cardNumber,
                "cardNumber": this.state.cardNumber.replace(/ /g,''),
                "name": this.state.cardHolderName,
                "expiry": this.state.expiry.replace(/ /g,''),
                "expiry_mm": this.state.expiry.replace(/ /g,'').slice(0, 2),
                "expiry_yy": this.state.expiry.replace(/ /g,'').slice(-2),
                "cvc": this.state.cvc,
                "save_card": this.state.saveCard
            }
        }
        this.props.card_submit(card_data)
    }
    render() {
        return (
            <div className={this.props.waiting ? "iframeCardNew ele_blur" : "iframeCardNew"}>
                <div>
                    <Cards
                        cvc={this.state.cvc}
                        expiry={this.state.expiry.replace(/ /g,'')}
                        focused={this.state.focus}
                        name={this.state.cardHolderName}
                        number={this.state.cardNumber}
                    />
                    <CreditCardInput
                        onError={({ inputName, err }) => {this.setState({card_error: true})}}
                        cardNumberInputProps={{ 
                            autoFocus: true,
                            name: "number",
                            value: this.state.cardNumber, 
                            disabled: this.props.waiting,
                            onChange: this.handleCardNumberChange, 
                            onFocus: this.handleInputFocus
                        }}
                        cardExpiryInputProps={{ 
                            name: "expiry",
                            value: this.state.expiry, 
                            disabled: this.props.waiting,
                            onChange: this.handleCardExpiryChange, 
                            onFocus: this.handleInputFocus 
                        }}
                        cardCVCInputProps={{ 
                            name: "cvc",
                            value: this.state.cvc, 
                            disabled: this.props.waiting,
                            onChange: this.handleCardCVCChange, 
                            onFocus: this.handleInputFocus 
                        }}
                        fieldClassName="input"
                    />
                    {this.state.showInstallment &&
                        <div class="checkInstallmentTextDiv">
                            <p>Your card is eligible for installments</p>
                            <span onClick={()=>this.setState({showInstallments: false, showInstallmentPlans: true})}>Check Installment Plans</span>
                        </div>
                    }
                    <Form onSubmit={this.handleSubmit}>
                        <div className="newInput">
                        <Input 
                            id="cardHolderInput"
                            type="text" 
                            name="name" 
                            placeholder="Card Holder Name"
                            autoComplete="off"
                            value={this.state.cardHolderName}
                            disabled={this.props.waiting}
                            onChange={this.handelCardHolderName}
                            onFocus={this.handleInputFocus}
                            validations={[required]} 
                        />
                        </div>
                        {this.props.can_save_card && this.props.can_save_card === true &&
                            <div class="disclaimer">
                                <p>your card data will be saved for future installments</p>
                            </div>
                        }
                        {this.props.user_can_save_card &&
                            <div class="form-group accept-terms">
                                <input 
                                    type="checkbox" 
                                    id="save-card"
                                    disabled={this.props.waiting}
                                    onChange={this.handelSaveCardChange}
                                />
                                <label for="save-card">Save card for future use</label>
                            </div>
                        }
                        {this.state.showInstallmentPlans &&
                            <div className="installment_container">
                                <p>Choose your plan</p>
                                <div className="installment_plans">
                                    {this.state.installmentPlans.map((plan, index) => (
                                        <div key={index} onClick={()=>this.handle_select_plan(plan, index)} className={`${this.state.selected_plan_index === index ? "selected" : ""}`}>
                                            <label>
                                                <p>{plan.tenure} months</p>
                                                <span>{plan.emi/100} {this.state.currency}/M</span>
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        }
                        <div className='text-center newCardFooter'>
                            {this.props.waiting ? 
                                <button className="newCardButton" disabled><div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div> </button> 
                            : 
                                this.state.card_error || !this.state.card_complate ?
                                    <button className="newCardButton" disabled>PAY {this.state.amount} {this.state.currency}</button>
                                    
                                :
                                    <Button className="newCardButton">PAY {this.state.amount} {this.state.currency}</Button>
                            }
                            <div className="secured_by">
                                <i className="fa fa-lock"></i>
                                Secured by Paymob
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }
}

export default InstallmentCard;